import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccessData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 59,
	height: 58,
	viewBox: "0 0 59 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1238_22418)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M57.0701 50.4701C56.6101 50.1301 53.0001 47.9601 53.0001 47.9601V24.6401H10.0001V48.1101C10.0001 48.1101 7.59006 49.6201 6.66006 50.1201C4.92006 51.0601 4.01006 52.4201 4.09006 54.4501C4.16006 56.2101 5.78006 57.6401 7.54006 57.6401H55.5701C57.4401 57.6401 58.9901 56.1301 59.0001 54.2601C59.0101 52.3201 58.3701 51.4101 57.0701 50.4701ZM48.0001 46.6401H15.0001V29.6401H48.0001V46.6401Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 33.6401V17.2401C33 14.7101 35.07 12.6401 37.6 12.6401H43",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 6.64014V38.6401",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.25 7.52C30.0504 7.52 31.51 6.06045 31.51 4.26C31.51 2.45955 30.0504 1 28.25 1C26.4495 1 24.99 2.45955 24.99 4.26C24.99 6.06045 26.4495 7.52 28.25 7.52Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.1899 12.72C49.1899 14.52 47.7299 15.98 45.9299 15.98C44.1299 15.98 42.6699 14.52 42.6699 12.72C42.6699 10.92 44.1299 9.45996 45.9299 9.45996C47.7299 9.45996 49.1899 10.92 49.1899 12.72Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 33.6401V17.1701C23 14.6801 20.96 12.6401 18.47 12.6401H15",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.84009 12.6501C7.84009 14.4501 9.30009 15.9101 11.1001 15.9101C12.9001 15.9101 14.3601 14.4501 14.3601 12.6501C14.3601 10.8501 12.9001 9.39014 11.1001 9.39014C9.30009 9.39014 7.84009 10.8501 7.84009 12.6501Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40 21.6401H50V45.0201C50 45.0201 53.6 47.1201 54.07 47.4501C55.37 48.3901 56.02 49.3101 56 51.2401C55.99 53.1201 54.44 54.6301 52.56 54.6301H4.46998C2.70998 54.6301 1.07998 53.1901 0.999976 51.4301C0.919976 49.3901 1.82998 48.0301 3.56998 47.0901C4.49998 46.5901 6.98998 44.9001 6.98998 44.9001V21.6401H17.99",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 27.6401V43.6401H45V27.6401",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25 49.6401H34",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1238_22418",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 59,
			height: 57.64,
			fill: "white"
		})
	}) })]
});
export default SvgAccessData;
